import { TargetsApiResponse } from './types';

export type State = {
  targets: TargetsApiResponse;
  loading: boolean;
};

export const state: State = {
  targets: [],
  loading: false,
};
